import globals from "./globals";
import $ from "cash-dom";
import { accordion } from "Utilities";

const layout = (function () {
    /**
     * Initialize Accordion instances
     */
    $(document).ready(function () {
        if ($(".layout-accordion").length) {
            if (globals.debug) console.log("layout-accordion initialized");

            $(".accordion-header").on("click", function (_el) {
                var body = $(_el).parents(".layoit-accordion").find(".accordion-body")[0];

                if (body.style.height) {
                    body.style.height = null;
                } else {
                    body.style.height = `${body.scrollHeight}px`;
                }
            });

            /*
            accordion({
                headerClass: ".accordion-header",
                bodyClass: ".accordion-content",
            });
            */
        }
    });
})();

export default layout;
